import type {ChangeEvent} from "react";
import type {PaymentMethod} from "../../../../domain/entities/PaymentMethod";
import {checkoutCopy} from "../../../i18n/checkout/es";
import styles from "../../../pages/checkout/CheckoutPage.module.css";

interface PaymentVoucherUploadProps {
    voucherConfig?: PaymentMethod["voucher"];
    file: File | null;
    onChange: (file: File | null) => void;
}

export const PaymentVoucherUpload = ({voucherConfig, file, onChange}: PaymentVoucherUploadProps) => {
    if (!voucherConfig) {
        return null;
    }

    const inputId = "payment-voucher";
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const fileList = event.target.files;
        onChange(fileList && fileList.length > 0 ? fileList.item(0) : null);
    };

    const accept = voucherConfig.acceptedMimeTypes?.join(",");
    const helperParts: string[] = [];

    if (voucherConfig.acceptedMimeTypes?.length) {
        helperParts.push(`${checkoutCopy.payment.voucherAccepted}: ${voucherConfig.acceptedMimeTypes.join(", ")}`);
    }

    if (voucherConfig.maxFileSizeMb) {
        helperParts.push(
            `${checkoutCopy.payment.voucherMaxSize.replace("{size}", voucherConfig.maxFileSizeMb.toString())}`,
        );
    }

  const helperText = helperParts.join(" · ");

  return (
    <section className={styles.paymentVoucher} aria-labelledby="payment-voucher-title">
      <h3 id="payment-voucher-title" className={styles.paymentFormTitle}>
        {checkoutCopy.payment.voucherHeading}
      </h3>
      <div className={styles.paymentField}>
        <label htmlFor={inputId} className={styles.visuallyHidden}>
          {checkoutCopy.payment.voucherLabel}
        </label>
        <input
          id={inputId}
          name="payment-voucher"
          type="file"
                    accept={accept}
                    onChange={handleChange}
                    required={voucherConfig.required}
                    className={styles.paymentFileInput}
                />
                <p className={styles.paymentFieldHelper}>
                    {helperText || checkoutCopy.payment.voucherHelper}
                    {file ? ` · ${file.name}` : ""}
                </p>
            </div>
        </section>
    );
};
